import React from 'react';
import classNames from 'classnames';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var renderImg = function renderImg(imgProps) {
  return /*#__PURE__*/React.createElement("img", _extends({
    alt: ""
  }, imgProps));
};

renderImg.displayName = "renderImg";

var ImageFormat = function ImageFormat(_ref) {
  var _classNames;

  var _ref$crop = _ref.crop,
      crop = _ref$crop === void 0 ? 'vertical' : _ref$crop,
      _ref$ratio = _ref.ratio,
      ratio = _ref$ratio === void 0 ? '1by1' : _ref$ratio,
      type = _ref.type,
      _ref$centered = _ref.centered,
      centered = _ref$centered === void 0 ? true : _ref$centered,
      _ref$render = _ref.render,
      render = _ref$render === void 0 ? renderImg : _ref$render,
      className = _ref.className,
      imageClassName = _ref.imageClassName,
      imgProps = _objectWithoutPropertiesLoose(_ref, ["crop", "ratio", "type", "centered", "render", "className", "imageClassName"]);

  return /*#__PURE__*/React.createElement("div", {
    className: classNames('img-format', (_classNames = {}, _classNames["img-format--crop-" + crop] = !!crop, _classNames["img-format--ratio" + ratio] = !!ratio, _classNames["img-format--centered"] = centered || !!type, _classNames["img-format--" + type] = !!type, _classNames), className)
  }, render(Object.assign({
    loading: 'lazy'
  }, imgProps, {
    className: classNames('img-format__img', imageClassName)
  })));
};

ImageFormat.displayName = "ImageFormat";

export default ImageFormat;
//# sourceMappingURL=index.es.js.map
